import "./Validation.css";
import { Button, Table } from "semantic-ui-react";

export const Validation = () => {
    return (
        <div id="transition-container-validation-a" className="validation-container transition-container">
            <div id="validation-header-a" className="validation-header">
                <Button id="button-validation-start" primary content="Start the validation" />
                <Button id="button-validation-download" primary disabled content="Download validation file" />
                <Button id="button-validation-clear" primary content="Clear logs" />
            </div>
            <Table id="table-validation" singleLine striped basic="very" unstackable>
                <Table.Header id="table-header-validation">
                    <Table.Row id="table-row-validation">
                        <Table.HeaderCell id="table-header-cell-validation-date">Date/Time</Table.HeaderCell>
                        <Table.HeaderCell id="table-header-cell-validation-calculation">Calculation Date</Table.HeaderCell>
                        <Table.HeaderCell id="table-header-cell-validation-user">User</Table.HeaderCell>
                        <Table.HeaderCell id="table-header-cell-validation-action">Action</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body></Table.Body>
            </Table>
        </div>
    );
};
